<template lang="pug">
  vm-table(:data="shippeds")
    template(slot="header")
      .d-flex.justify-content-between
        div
    template(slot="thead")
      vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
      vm-th
    template(slot-scope="{data}")
      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
        vm-td {{data[indextr]['remission_number']}}
        vm-td {{data[indextr]['details'] ? data[indextr]['details'][0]['quantity'] : ''}}
</template>

<script>

export default {
  name: 'ShippedTab',
  props: {
    shippeds: {
      type: Array
    }
  },  
  data: () => ({
    columns: [
      'remission_number',
      'quantity'
    ]  
  })
}
</script>
